// extracted by mini-css-extract-plugin
export default {"list":"AttachmentsList_list__YHI+1","item":"AttachmentsList_item__wcg2T"};